import { useState, useEffect } from 'react';
import './Pagination.css';

export default function Pagination({ page, total=10000, onPageChange, rowsPerPage=100, loading }) {
    const handlePageChange = (page) => {
        setCurrentPage(page);
        onPageChange(page);
    }
    const [currentPage, setCurrentPage] = useState(page);
    const totalPages = Math.ceil(total / rowsPerPage);

    useEffect(() => {
        setCurrentPage(page);
    }, [page]);

    return (
        loading ? <div>...</div> :
            <div className="pagination">
                <div className="pagination-info">
                    Rows: {((currentPage - 1) * rowsPerPage) + 1} - {Math.min(currentPage * rowsPerPage, total)} of {total}
                </div>
                <div className="pagination-controls">
                    {totalPages > 1 && (
                        <>
                            {currentPage > 1 && <button className="btn btn-primary" onClick={() => handlePageChange(currentPage - 1)}><i className="material-icons" style={{verticalAlign: 'middle', margin: '0px', padding: '0px', fontSize: '16px'}}>chevron_left</i></button>}
                            {[...Array(7)].map((_, i) => {
                                const pageNum = currentPage + (i - 3);
                                if (pageNum > 0 && pageNum <= totalPages ) {
                                    return (
                                        <button 
                                            key={i}
                                            className={`btn ${pageNum === currentPage ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handlePageChange(pageNum)}
                                            style={{width: '40px'}}
                                        >
                                            {pageNum}
                                        </button>
                                    );
                                }
                                return null;
                            })}
                            {currentPage < totalPages && <button className="btn btn-primary" onClick={() => handlePageChange(currentPage + 1)}><i className="material-icons" style={{verticalAlign: 'middle', margin: '0px', padding: '0px', fontSize: '16px'}}>chevron_right</i></button>}
                        </>
                    )}
                </div>
            </div>
        
    )
}